import { Injectable } from '@jkhy/frontend-utils/di';
import { StorageProvider } from '../types';
import { WindowService } from './window.service';
@Injectable()
export class LocalStorageService extends StorageProvider {
    constructor(window: WindowService) {
        super(window.localStorage);
    }
}
